import { Dispatch } from 'redux';

export const RESET_STATE = 'RESET_STATE';

export function resetState(dispatch: Dispatch) {
  dispatch({ type: RESET_STATE, payload: {} });
}
